export default "/assets/website/images/arrow-right.svg?a59ad6f800c5755938df9799e68c185e";